<template>
  <div>
    <el-form :model="form" ref="form" label-width="80px">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item :label="$t('mv.mvName')">
            <el-input v-model="form.mvName__icontains" :placeholder="$t('mv.mvNamePlaceholder')" clearable></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item :label="$t('common.singerName')">
            <el-input v-model="form.singerName" :placeholder="$t('common.singerNamePlaceholder')" clearable></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="UPC">
            <el-input v-model="form.upc" :placeholder="$t('common.upcPlaceholder')" clearable></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item :label="$t('common.status')">
            <el-select v-model="form.status" :placeholder="$t('common.statusPlaceholder')" clearable>
              <el-option v-for="(item, key) in statusMap" :key="key" :value="+key" :label="item"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item v-if="userInfo.roleType === 1 || userInfo.roleType === 2" :label="$t('common.relateCompany')">
            <el-select
              v-model="form.relateCompanyIdList"
              clearable
              filterable
              class="search-item"
            >
              <el-option v-for="rc in companyList" :key="rc.companyName" :label="rc.companyName" :value="+rc.companyId"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item :label="$t('common.publicTime')">
            <el-date-picker
              v-model="form.publicTime"
              clearable
              :placeholder="$t('common.publicTimePlaceholder')"
              class="search-item"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item :label="$t('common.uploadTime')">
            <el-date-picker
              v-model="form.uploadTime"
              clearable
              class="search-item"
              :placeholder="$t('common.uploadTimePlaceholder')"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-col>

        <el-button class="right" type="primary" @click="$emit('search')" :loading="loading">{{ $t('common.search') }}</el-button>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { statusMap } from '../const'
import { mapGetters } from 'vuex'
import { cloneDeep } from 'lodash-es'
import { ROLE_TYPE_ENUM } from '@/views/person/const'

export default {
  name: 'SearchForm',

  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      statusMap,
      form: {
        status: 0,
        mvName__icontains: '',
        singerName: '',
        upc: '',
        publicTime: '',
        uploadTime: '',
        relateCompanyIdList: ''
      }
    }
  },

  computed: {
    ...mapGetters([
      'relateCompanyList',
      'agentCompanyList',
      'userInfo'
    ]),
    /**
     * @returns {Boolean}
     */
    needCompanyInfo() {
      const { roleType } = this.userInfo
      return roleType === ROLE_TYPE_ENUM.COMPANY.code || roleType === ROLE_TYPE_ENUM.OTHER.code
    },

    /**
     * @returns {Array}
     */
    companyList() {
      if (this.needCompanyInfo) {
        return this.agentCompanyList.filter(item => item.agentCompanyId)
          .map(item => {
            return {
              companyId: item.agentCompanyId,
              companyName: item.agentCompanyName
            }
          }).concat([{ companyName: '--自己--', companyId: 0 }])
      } else {
        return this.relateCompanyList.filter(item => item.relateCompanyId)
          .map(item => {
            return {
              companyId: item.relateCompanyId,
              companyName: item.relateCompanyName
            }
          }).concat([{ companyName: '--自己--', companyId: 0 }])
      }
    },

  },
  methods: {
    getFormData() {
      const form = cloneDeep(this.form)
      if (form.status === 0) {
        form.status = void (0)
      }

      if (form.uploadTime) {
        form.uploadTime__gte = `${form.uploadTime} 00:00:00`
        form.uploadTime__lte = `${form.uploadTime} 23:59:59`
        form.uploadTime = void (0)
      }
      if (form.relateCompanyIdList === 0) {
        form.relateCompanyIdList = []
      } else if (!form.relateCompanyIdList) {
        form.relateCompanyIdList = void (0)
      } else {
        form.relateCompanyIdList = [form.relateCompanyIdList]
      }

      return form
    }
  }
}
</script>

<style lang="scss" scoped>
.search-item {
  width: 100%;
}

.right {
  float: right;
  margin-right: 12px;
}

.el-form .el-form-item  {
  margin-bottom: 8px !important;
}
</style>
